const template = require('./sections-articles-template.html');

module.exports = function SectionsArticlesDirective(helpCenterService) {
    return {
        restrict: 'E',
        scope: {
            categoryId: '='
        },
        template: template,
        link: function (scope) {
            scope.categories = [];
            scope.sections = [];
            scope.articles = [];
            scope.currentCategory = {};
            scope.currentSectionName = "";

            // Fetch categories on initialization
            helpCenterService.getCategories()
                .then(function (categories) {
                    scope.categories = categories;
                    scope.setCurrentCategoryName();
                    scope.$evalAsync();
                })
                .catch(function (error) {
                    console.error("Error fetching categories:", error);
                });

            // Watch for changes in categoryId to fetch sections
            scope.$watch('categoryId', function (newCategoryId) {
                if (newCategoryId) {
                    helpCenterService.getSectionsByCategoryId(newCategoryId)
                        .then(function (sections) {
                            scope.sections = sections.map(section => {
                                section.expanded = true; // Expanded by default
                                return section;
                            });

                            // Load articles for all sections initially
                            scope.sections.forEach(section => {
                                helpCenterService.getArticlesBySectionId(section.id)
                                    .then(function (articles) {
                                        section.articles = articles;
                                        scope.$evalAsync();
                                    })
                                    .catch(function (error) {
                                        console.error("Error fetching articles:", error);
                                    });
                            });

                            scope.articles = [];
                            scope.$evalAsync();
                        })
                        .catch(function (error) {
                            console.error("Error fetching sections:", error);
                        });
                }
            });

            scope.setCurrentCategoryName = function () {
                const selectedCategory = scope.categories.find(category => category.id === scope.categoryId);
                if (selectedCategory) {
                    scope.currentCategory.name = selectedCategory.name;
                }
            };

            scope.selectCategory = function (category) {
                scope.currentCategory = category;
                scope.currentSectionName = "";
                helpCenterService.getSectionsByCategoryId(category.id)
                    .then(function (sections) {
                        scope.sections = sections.map(section => {
                            section.expanded = true; // Expanded by default
                            return section;
                        });

                        // Load articles for all sections initially
                        scope.sections.forEach(section => {
                            helpCenterService.getArticlesBySectionId(section.id)
                                .then(function (articles) {
                                    section.articles = articles;
                                    scope.$evalAsync();
                                })
                                .catch(function (error) {
                                    console.error("Error fetching articles:", error);
                                });
                        });

                        scope.articles = [];
                        scope.$evalAsync();
                    })
                    .catch(function (error) {
                        console.error("Error fetching sections:", error);
                    });
            };

            // Toggle section expansion state
            scope.toggleSection = function (selectedSection) {
                selectedSection.expanded = !selectedSection.expanded;

                // Only fetch articles if expanding and not already loaded
                if (selectedSection.expanded && !selectedSection.articles) {
                    helpCenterService.getArticlesBySectionId(selectedSection.id)
                        .then(function (articles) {
                            selectedSection.articles = articles;
                            scope.$evalAsync();
                        })
                        .catch(function (error) {
                            console.error("Error fetching articles:", error);
                        });
                }
            };

            scope.showHelpCenter = function () {
                scope.$parent.isCategorySelected = false;
                scope.$parent.showLandingPageTemplate();
            };

            scope.showArticle = function (article) {
                scope.$parent.showArticle(article);
            }
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help-center/sections-articles-directive.js
 **/